import emailRocket from "../media/emailRocket.avif"
import "../css/admin.css"
function Emails(){
    return (
        <div className="EmailWrap">
              <img src={emailRocket} alt="" />
              <p>To access your mailbox you will have to use your mobile Gmail app.</p>
        </div>
    )
}
export default Emails;